import list from '../../api/list'
import { Object } from 'core-js'
import router from '@/router'
import store from '..'



const state = () => ({
  isSearching: false,
  lastSelectedJewel: null,
  lastSelectedProduct: null,
  currentCategory: null,

  //object that populates request search body
  searchJewel: {
    text: null, // string
    stoneType: null, // string
    stoneColor: null, // string
    stoneShape: null, // string
    goldColor: null, // string
    goldColorId: null, // string
    category: null, // int
    subCategory: null, // int
    minPrice: null, // double
    maxPrice: null, // double
    sku: null, // string,
    jewellery: null, // boolean,
    productType: null,
    sorting: null,
    minAvailability: 0,
    numberOfElements: null,
    jewelSection: [],
    excludeJewelSection: [],
    backoffice: false
  },
  subCategoriesToShow: [],
  categories: [],
  subCategories: [],
  stoneTypes: [],
  allStoneTypes: [],
  stoneShapes: [],
  golds: [],
  jewels: [],
  style: "gioielleria",
});


// actions
const actions = {
  search({ commit }, search) {
    commit("setSearching", true);
    list.searchJewels((searchJewel) => {
      commit("setJewelsList", searchJewel);
    }, search);
  },
  getListCategories({ commit }, search) {
    list.getList((searchJewel) => {
      commit("listCategories", searchJewel);
    }, search);
  },
  getListCategoriesWithCb({ commit }, payload) {
    list.getList((searchJewel) => {
      commit("listCategories", searchJewel);
      payload.cb(searchJewel);
    }, payload.search, payload.params);
  },
  getListCategoriesExtra({ commit }, search) {
    list.getList((searchJewel) => {
      commit("listCategories", searchJewel);
    }, search);
  },
  getListSubCategories({ commit }, search) {
    list.getList((searchJewel) => {
      commit("listSubCategories", searchJewel);
    }, search);
  },
  getListSubCategoriesExhibitors({ commit }, search) {
    list.getList((searchJewel) => {
      commit("listSubCategoriesExhibitors", searchJewel);
    }, search);
  },
  getListStoneShapes({ commit }, payload) {
    list.getList(
      (searchJewel) => {
        commit("listStoneShapes", searchJewel);
      },
      payload.search,
      payload.params
    );
  },
  getListStoneColors({ commit }, payload) {
    list.getList(
      (searchJewel) => {
        commit("listStoneColors", searchJewel);
      },
      payload.search,
      payload.params
    );
  },
  getListAllStoneColors({ commit }, payload) {
    list.getList((searchJewel) => {
      commit("listAllStoneColors", searchJewel);
    }, payload.search);
  },
  getListGoldTypes({ commit }, search) {
    list.getList((searchJewel) => {
      commit("listGoldTypes", searchJewel);
    }, search);
  },
};

// mutations
const mutations = {
  //searching boolean value that shows the loader if there's a check
  setSearching(state, value) {
    state.isSearching = value;
  },
  setLastSelectedJewel(state, value) {
    state.lastSelectedJewel = value;
  },
  setLastSelectedProduct(state, value) {
    state.lastSelectedProduct = value;
  },
  //set the style gioielleria or oreficeria (useless at 16/08/2021, it'll be useful in the future)
  setStyle(state, style) {
    state.style = style;
  },
  setJewelsList(state, values) {
    state.jewels = values ? values.data : [];
    state.isSearching = false;
  },
  listCategories(state, values) {
    let val
    state.categories = values.filter(function (obj) {
      return obj.toShow;
    });
    val = values.find(a => a.id == router.currentRoute.params.typeId)
    if (!router.currentRoute.params.typeId)
      val = { productType: router.currentRoute.params.productType };
    setCurrentCat(state, val ? Object.assign({}, val, null) : {});
  },
  // this function sets the current category
  setCurrentCategory(state, obj) {
    setCurrentCat(state, obj)
  },
  listSubCategories(state, values) {
    state.subCategories = values;
    state.subCategoriesToShow = state.subCategories.filter(
      obj => obj.jewelTypeId == state.currentCategory?.id
    )
  },
  listSubCategoriesExhibitors(state, values) {
    state.subCategories = values;
    state.subCategoriesToShow = state.subCategories.filter(
      (obj) => obj.jewelTypeId == 7
    );
  },
  listGoldTypes(state, values) {
    state.golds = values;
  },
  // this function gets the stones from and a API and that sort the stones by the shape
  listStoneColors(state, values) {
    state.stoneTypes = orderStonesByShape(values);
  },

  listStoneShapes(state, values) {
    state.stoneShapes = values;
  },

  // this function gets the stones from and a API and that sort the stones by the shape
  listAllStoneColors(state, values) {
    state.allStoneTypes = orderStonesByShape(values);
  },

  // this function sets the value in the jewelsearch object
  setJewelSearch(state, obj) {
    state.searchJewel[obj.label] = obj.value;
  },

  // this function resets the value in the jewelsearch object
  resetJewelSearch(state) {
    state.searchJewel = {
      text: null, // string
      stoneType: null, // string
      stoneColor: null, // string
      stoneShape: null, // string
      goldColor: null, // string
      goldColorId: null, // string
      subCategory: null, // int
      minPrice: null, // double
      maxPrice: null, // double
      sku: null, // string,
      sorting: null,
      productType: null,
      category: null,
      minAvailability: 0,
      jewelSection: [],
      excludeJewelSection: [],
      backoffice: false
    };
  },
};


function setCurrentCat(state, obj) {
  state.currentCategory = obj
}

const orderStonesByShape = function (values) {
  let objar = {}
  let orderValues = []
  let ultimateValues = []
  values.forEach(el => {
    let type = el.type
    if (objar[type]) {
      objar[type].push(el);
    } else {
      objar[type] = [el];
    }
  });
  for (const key in objar) {
    if (objar.hasOwnProperty(key)) {
      const el = objar[key];
      orderValues.push(...el);
    }
  }

  objar = {};
  orderValues.forEach((el) => {
    let shape = el.color.substring(el.color.indexOf("-") + 1).substring(0, 2);
    if (objar[shape]) {
      objar[shape].push(el);
    } else {
      objar[shape] = [el];
    }
  });

  for (const key in objar) {
    if (objar.hasOwnProperty(key)) {
      const el = objar[key];
      ultimateValues.push(...el);
    }
  }

  return ultimateValues;
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
